import React from "react";
import {
  GameCondition,
  GameMode,
  TeamInfoResponse,
} from "../api/copenhunt/v1/copenhunt_pb";
import AddLocationModal from "./modals/AddLocationModal";
import BroadcastModal from "./modals/BroadcastModal";
import EditGameModal from "./modals/EditGameModal";

interface AdminControlPanelProps {
  gameId: string;
  condition: GameCondition | undefined;
  teamInfoById: { [key: string]: TeamInfoResponse };
  onStart: () => void;
  onPause: () => void;
  onUnpause: () => void;
  isPaused: boolean | undefined;
  mode: GameMode;
  pingIntervalSeconds: number;
}

const AdminControlPanel: React.FC<AdminControlPanelProps> = ({
  gameId,
  condition,
  teamInfoById,
  onStart,
  onPause,
  onUnpause,
  isPaused,
  mode,
  pingIntervalSeconds,
}) => {
  return (
    <div className="control">
      {condition === GameCondition.FINISHED ? (
        <></>
      ) : (
        <>
          {condition !== undefined &&
          condition === GameCondition.NOT_STARTED ? (
            <button onClick={onStart}>Start Game</button>
          ) : isPaused ? (
            <button onClick={onUnpause}>Unpause Game</button>
          ) : (
            <button onClick={onPause}>Pause Game</button>
          )}
          <EditGameModal
            gameId={gameId}
            mode={mode}
            pingIntervalSeconds={pingIntervalSeconds}
            teamInfoById={teamInfoById}
          />
          <AddLocationModal gameId={gameId} />
        </>
      )}
      <BroadcastModal gameId={gameId} />
    </div>
  );
};

export default AdminControlPanel;
